import axios from 'axios';

const URL = 'https://expense-app-be-default-rtdb.firebaseio.com/tiptier.json'

export async function commitToDatabase(details: any){
    const output = await axios.post(URL, details)

    return output.data
}